export const getRecipient = message =>
  message.from_self ? message.recipients[0] : message.sender;
